import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trash-bin__page-wrap" }
const _hoisted_2 = { class: "trash-bin__page-title" }
const _hoisted_3 = { class: "trash-bin__table-container" }
const _hoisted_4 = { class: "trash-bin__table-header" }
const _hoisted_5 = { class: "trash-bin__info-text" }
const _hoisted_6 = { class: "trash-bin__table-contains" }

import { i18n } from '@/i18n';
import { storeToRefs } from 'pinia';
import { useTrashBinStore } from './useTrashBinStore';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent';
import { onMounted, ref } from 'vue';
import { TableContentProperty } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import ControlViewTab from '../components/ControlViewTab.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const trashBinStore = useTrashBinStore();
const { state } = storeToRefs(trashBinStore);
const t = i18n.t;
let renderingKey = 0;

const {
  $reset,
  sortTableContentItems,
  reloadTable,
  onChangePaging,
  fetchTableContentProperties,
  fetchItems,
  calcDeleteBusiness,
  deleteAggregateBusiness,
  deleteBusiness,
  updateIsTrash,
  itemCheck,
  onClickTrashBinAllSelect,
} = trashBinStore;

const isRefreshTable = ref(false);

onMounted(async () => {
  await init();
});

/**
 * 初期化処理
 * @param viewValue - 初期化時のタブ
 */
const init = async (viewValue?: 'aggregateBusiness' | 'business') => {
  $reset();
  state.value.nowView = viewValue ?? 'aggregateBusiness';
  state.value.tableContentProperties = fetchTableContentProperties();
  fetchItems(state.value.nowView);

  renderingKey += 1;
};

/**
 * 画面の表示を変更
 * @param viewValue - 変更する画面
 */
const controlViewTabOnClick = (viewValue: 'aggregateBusiness' | 'business') => {
  init(viewValue);
  reloadTable();
};

/**
 * 削除ボタン押下時の処理
 */
const deleteButtonOnClick = () => {
  switch (state.value.nowView) {
    case 'aggregateBusiness':
      state.value.isDeleteAggregateBusinessModalOpened = true;
      return;
    case 'business':
      state.value.isDeleteBusinessModalOpened = true;
  }
  return;
};

/**
 * 復元ボタン押下時の処理
 */
const recoverButtonOnClick = () => {
  state.value.isUpdateModalOpened = true;
  return;
};

/**
 * ページを更新する処理
 */
const reloadPage = () => {
  location.reload();
  return;
};

/**
 * 集計削除モーダル確定押下時の処理
 */
const deleteAggregateBusinessModalNext = async () => {
  await deleteAggregateBusiness();
  if (state.value.isErrorModalOpened) return;
  init(state.value.nowView);
  onChangePaging({
    pageSize: state.value.pagingOptions.pageSize,
    offset: 0,
    nextOffset: undefined,
    totalResultsAvailable: undefined,
    returnCount: 0,
  });
  reloadTable();
  isRefreshTable.value = true;
  isRefreshTable.value = false;
};

/**
 * 取引削除モーダル確定押下時の処理
 */
const deleteBusinessModalNext = async () => {
  await deleteBusiness();
  if (state.value.isErrorModalOpened) return;
  init(state.value.nowView);
  onChangePaging({
    pageSize: state.value.pagingOptions.pageSize,
    offset: 0,
    nextOffset: undefined,
    totalResultsAvailable: undefined,
    returnCount: 0,
  });
  reloadTable();
  isRefreshTable.value = true;
  isRefreshTable.value = false;
};

/**
 * 復元モーダル確定押下時の処理
 */
const updateModalNext = async () => {
  await updateIsTrash();
  if (state.value.isErrorModalOpened) return;
  init(state.value.nowView);
  onChangePaging({
    pageSize: state.value.pagingOptions.pageSize,
    offset: 0,
    nextOffset: undefined,
    totalResultsAvailable: undefined,
    returnCount: 0,
  });
  reloadTable();
  isRefreshTable.value = true;
  isRefreshTable.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('ゴミ箱')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextButton, {
          "button-style": "btn-primary",
          size: "btn-md",
          "on-click": deleteButtonOnClick,
          class: "trash-bin__button",
          disabled: !!!_unref(state).checkedIds.length
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('完全削除する')), 1)
          ], undefined, true),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(TextButton, {
          "button-style": "btn-secondary",
          size: "btn-md",
          "on-click": recoverButtonOnClick,
          class: "trash-bin__button",
          disabled: !!!_unref(state).checkedIds.length
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('管理表に戻す')), 1)
          ], undefined, true),
          _: 1
        }, 8, ["disabled"]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('ゴミ箱の取引は、45日後に自動的に削除されます。')), 1),
        _createVNode(ControlViewTab, {
          class: "trash-bin__control-view-tab",
          "now-view": _unref(state).nowView,
          onClick: controlViewTabOnClick
        }, null, 8, ["now-view"]),
        _createVNode(Pagination, {
          "paging-options": _unref(state).pagingOptions,
          "is-loading": _unref(state).loadingState.status.type === 'loading',
          class: "pagination",
          onOnChangePage: _cache[0] || (_cache[0] = ($event: any) => (_unref(onChangePaging)($event)))
        }, null, 8, ["paging-options", "is-loading"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createBlock(_unref(NewBaseTableContent), {
          key: _unref(renderingKey),
          "prop-table-content-properties": _unref(state).tableContentProperties,
          "prop-display-objects": _unref(state).tableContentItems,
          "prop-loading-status": _unref(state).loadingState,
          "prop-table-type": 'trash',
          "prop-is-reset": isRefreshTable.value,
          "prop-all-of-result": _unref(state).pagingOptions.totalResultsAvailable,
          "prop-checked-ids": _unref(state).checkedIds,
          "prop-is-all-selected": _unref(state).isAllSelected,
          class: "trash-bin-items-table__contains trash-bin-items-table__contains--table",
          onChecked: _cache[1] || (_cache[1] = ($event: any) => (_unref(itemCheck)($event))),
          onOnClickSort: _cache[2] || (_cache[2] = (sortKey, isAsc) => _unref(sortTableContentItems)(sortKey, isAsc)),
          onReload: _unref(reloadTable),
          onOnClickTrashBinAllSelect: _unref(onClickTrashBinAllSelect)
        }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status", "prop-is-reset", "prop-all-of-result", "prop-checked-ids", "prop-is-all-selected", "onReload", "onOnClickTrashBinAllSelect"]))
      ])
    ]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).isDeleteAggregateBusinessModalOpened,
      icon: "error",
      "color-style": "error",
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('削除'),
      onOnBack: _cache[3] || (_cache[3] = 
        () => {
          _unref(state).isDeleteAggregateBusinessModalOpened = false;
          return;
        }
      ),
      onOnNext: _cache[4] || (_cache[4] = ($event: any) => (deleteAggregateBusinessModalNext()))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('取引を完全削除します')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('削除モーダル関連取引削除', { businessesNumber: _unref(calcDeleteBusiness)() })), 1),
        _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('削除された取引は復元できません。')), 1),
        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('よろしいですか？')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).isDeleteBusinessModalOpened,
      icon: "error",
      "color-style": "error",
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('削除'),
      onOnBack: _cache[5] || (_cache[5] = 
        () => {
          _unref(state).isDeleteBusinessModalOpened = false;
          return;
        }
      ),
      onOnNext: _cache[6] || (_cache[6] = ($event: any) => (deleteBusinessModalNext()))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('取引を完全削除します')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('削除された取引は復元できません。')), 1),
        _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('よろしいですか？')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).isUpdateModalOpened,
      icon: "info",
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('戻す'),
      onOnBack: _cache[7] || (_cache[7] = 
        () => {
          _unref(state).isUpdateModalOpened = false;
          return;
        }
      ),
      onOnNext: _cache[8] || (_cache[8] = ($event: any) => (updateModalNext()))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('取引を管理表に戻します')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('選択された取引を管理表に復活させます。')), 1),
        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('よろしいですか？')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).isErrorModalOpened,
      icon: "error",
      "color-style": "error",
      "next-button-label": "確認",
      onOnNext: _cache[9] || (_cache[9] = ($event: any) => (reloadPage()))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('エラーが発生しました。')), 1)
      ]),
      description: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('再度やり直してください。')), 1)
      ]),
      _: 1
    }, 8, ["modal-state"])
  ]))
}
}

})